import React from "react";
import InnerHTML from "dangerously-set-html-content";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import Loader from "./Loader";
const MainComponent = ({ Heading, data, button, Route }) => {
  return (
    <div className="table-container xs ">
      <div
        className="latest-transaction-container"
        style={{
          display: "inline-block",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div className="table-inner-container">
          <div className="table-inner-container">
            <h3>{Heading}</h3>
            {!data ? (
              <div>
                <Loader />
              </div>
            ) : (
              <div>
                <InnerHTML key={data} html={data} />
              </div>
            )}

            <div className="table-btn-container">
              <Link className="reg-btn" to={Route}>
                {button}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainComponent;
